import useJnjBranding from "@jmc/utils/hooks/useJnjBranding";
import React from "react";

import { FormAssemblyBranded } from "./FormAssemblyBranded";
import { FormAssemblyLegacy } from "./FormAssemblyLegacy";

interface Props {
    formAssemblyRestUrl: string;
    proxyUrl?: string;
    formAssemblyDomain?: string;
    compliance?: boolean;
    complianceText?: string;
    params?: object;
    title: string;
}

export const FormAssembly = (props: Props): JSX.Element => {
    const { jnjFullBranded } = useJnjBranding();

    return jnjFullBranded ? <FormAssemblyBranded {...props} /> : <FormAssemblyLegacy {...props} />;
};

export default FormAssembly;
